import { render, staticRenderFns } from "./jksb.vue?vue&type=template&id=8e6e6cfe&scoped=true"
import script from "./jksb.vue?vue&type=script&lang=js"
export * from "./jksb.vue?vue&type=script&lang=js"
import style0 from "./jksb.vue?vue&type=style&index=0&id=8e6e6cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6e6cfe",
  null
  
)

export default component.exports